import axios from 'axios';

export const profileModuleOptionApi = axios.create({
    baseURL: `${process.env.REACT_APP_BACKEND!}api/profile-module-option`,
    headers: {
        'Content-Type': 'application/json'
    }
})